module.exports = __webpack_public_path__ + "static/media/pix5.9b8c6694.jpg";